module.exports = __webpack_public_path__ + "img/ultimate_tz.4c6f4840.png";